/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLunchDiningIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-lunch-dining"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 21.8Q2.73 21.8 1.96 21.04Q1.2 20.27 1.2 19.15L1.2 16.88Q1.2 16.32 1.59 15.94Q1.98 15.55 2.52 15.55L21.48 15.55Q22.02 15.55 22.41 15.94Q22.8 16.32 22.8 16.88L22.8 19.15Q22.8 20.27 22.04 21.04Q21.27 21.8 20.15 21.8ZM11.95 13.55Q11.95 13.55 11.47 13.55Q11 13.55 10.45 14.05Q9.9 14.55 8.35 14.55Q6.8 14.55 6.29 14.05Q5.78 13.55 4.83 13.55Q4.13 13.55 3.69 13.85Q3.25 14.15 2.52 14.38Q2.02 14.53 1.61 14.16Q1.2 13.8 1.2 13.22Q1.2 12.65 1.56 12.21Q1.93 11.78 2.45 11.5Q2.88 11.3 3.41 11.1Q3.95 10.9 4.83 10.9Q6.38 10.9 6.89 11.4Q7.4 11.9 8.35 11.9Q9.3 11.9 9.85 11.4Q10.4 10.9 11.95 10.9Q13.5 10.9 14.06 11.4Q14.63 11.9 15.57 11.9Q16.52 11.9 17.07 11.4Q17.63 10.9 19.18 10.9Q20.05 10.9 20.59 11.1Q21.13 11.3 21.55 11.5Q22.07 11.78 22.44 12.21Q22.8 12.65 22.8 13.22Q22.8 13.8 22.39 14.16Q21.98 14.53 21.48 14.38Q20.77 14.15 20.38 13.85Q19.98 13.55 19.27 13.55Q18.32 13.55 17.73 14.05Q17.13 14.55 15.57 14.55Q14.03 14.55 13.46 14.05Q12.9 13.55 11.95 13.55ZM11.99 2.2Q11.99 2.2 12.98 2.2Q13.97 2.2 15.91 2.55Q17.85 2.9 19.38 3.66Q20.9 4.42 21.85 5.64Q22.8 6.85 22.8 8.57Q22.8 9.13 22.41 9.51Q22.02 9.9 21.48 9.9L2.52 9.9Q1.98 9.9 1.59 9.51Q1.2 9.13 1.2 8.57Q1.2 6.85 2.14 5.64Q3.08 4.42 4.6 3.66Q6.13 2.9 8.06 2.55Q10 2.2 11.99 2.2Z" fill={color} />
    </svg>
  );
}
